<template>
  <div>
    <ButtonSwipe class="no-print" :options="availableColumns" :multiple="true"
                 v-model="visibleColumns"
                 @change="track(getSelectedGridColumns($event), 'Selecionou coluna')" />
    <div class="mt-3"></div>
    <DataGrid :records="filteredReport" @export="emmitExport" @print="emmitPrint" />
  </div>
</template>

<script>
import Tracker from '@/services/tracker';
import ButtonSwipe from './ButtonSwipe';
import DataGrid from './DataGrid';

const columnsToRemove = ['secondTierWinValue', 'numBonus', 'numSupplierWinBonus'];
export default {
  name: 'ReportResult',
  components: {
    ButtonSwipe,
    DataGrid,
  },
  data() {
    return {
      visibleColumns: [],
    };
  },
  props: {
    report: {
      type: Object,
      required: true,
      validator(obj) {
        return obj && Object.prototype.hasOwnProperty.call(obj, 'reportResult');
      },
    },
  },
  computed: {
    filteredReport() {
      const reportCopy = Object.assign({}, this.report.reportResult);
      columnsToRemove.forEach((column) => {
        if (this.columnMustBeRemoved(reportCopy, column)) {
          reportCopy.fields = reportCopy.fields.filter(f => f.key !== column);
          reportCopy.lines.map((line) => {
            // eslint-disable-next-line no-param-reassign
            delete line[column];
            return line;
          });
          reportCopy.totals = reportCopy.totals.filter(f => f.column !== column);
        }
      });

      if (this.visibleColumns.length > 0) {
        const filteredFields = reportCopy.fields.filter(f => this.visibleColumns.includes(f.key));
        if (filteredFields.length > 0) {
          reportCopy.fields = filteredFields;
        }
      }

      reportCopy.fields = reportCopy.fields.map(field => ({
        ...field,
        headerTitle: field.label,
        sortable: true,
      }));

      reportCopy.lines = reportCopy.lines.map(line => ({
        ...line,
        datEvent: new Date(line.datEvent),
      }));

      return reportCopy;
    },
    availableColumns() {
      let availableColumns = this.report.reportResult.fields
        .map(f => ({ description: f.label, value: f.key }));

      columnsToRemove.forEach((column) => {
        if (this.columnMustBeRemoved(this.report.reportResult, column)) {
          availableColumns = availableColumns.filter(ac => ac.value !== column);
        }
      });

      return availableColumns;
    },
  },
  methods: {
    emmitExport() {
      this.$emit('export');
    },
    emmitPrint() {
      this.$emit('print');
    },
    track(label, action) {
      Tracker.track(label, action);
    },
    getSelectedGridColumns(value) {
      return this.availableColumns
        .filter(ac => value.includes(ac.value))
        .map(ac => ac.description)
        .join('; ') || 'Nenhum';
    },
    columnMustBeRemoved(result, column) {
      return result.fields.some(f => f.key === column)
             && result.totals.filter(t => t.column === column)[0].value === 0;
    },
  },
};
</script>
